<footer class="bg-gray-dark px-16 py-20">
  <div class="mx-auto">
    <div class="flex flex-col justify-center text-center md:flex-row md:items-center">
      <p class="text-white small">
        <span class="mr-4">&copy;{{ year }} Iowa Code Camp. All rights reserved.</span>
      </p>
      <p class="small md:ml-auto text-white">
        Website by <a class="a" href="https://wewritecode.com/" target="_blank">We Write Code</a>
      </p>
    </div>
  </div>
</footer>
